import React, { Component, KeyboardEvent, ChangeEvent, MouseEvent } from "react";
import {
    Row, Col, Button, Modal, ModalBody, ModalHeader, ModalFooter, Spinner, UncontrolledTooltip, Badge, Nav, NavItem, NavLink, TabContent, TabPane
} from "reactstrap";
import * as KSLPlusAPI from "../services/KSLPlusAPI"

import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
// @ts-ignores
import BootstrapTable from 'react-bootstrap-table-next';
// @ts-ignore
import cellEditFactory from 'react-bootstrap-table2-editor';
// @ts-ignore
import paginationFactory from 'react-bootstrap-table2-paginator';

import Chart from "react-google-charts";

import { Kennzahl } from './KennzahlComp';

import { HHSummiertDoppisch } from './HHSummiertDoppischComp';
import { ProduktSpezHaushalt } from './ProduktSpezHaushaltComp';


import * as Utilities from "./Utilities"

import { env } from '../env';

import '../custom.css';
import { ENGINE_METHOD_PKEY_ASN1_METHS } from "constants";
import { GLHaushalt } from "./GLHaushaltComp";

import { HaushaltsNavTree, EbenenTyp } from './HaushaltsNavTreeComp';
import { ProduktNavTree, EbenenTyp as EbenenTypDoppisch } from './ProduktNavTreeComp';

type State = {
    ready: boolean,
    hhPr: KSLPlusAPI.HaushaltSummiert | null,
    hhPRModal: boolean,
    expanded: number[],
    hhPrs: { [key: string]: KSLPlusAPI.HaushaltSummiert }
    hhGL: KSLPlusAPI.HaushaltsEbene | null;
    hierDoppisch: KSLPlusAPI.HaushaltsHiearchieDoppik| null;
    hierKameral: KSLPlusAPI.HaushaltsEbene | null;
    selected: string;
    abc: KSLPlusAPI.ABCResult | null;
}

type Props = {  
    buchungsart: number;         
    abc: KSLPlusAPI.ABCResult;
    jahr: number;
    kunde: number;
    gemeinde: number;
    plantyp: number;
    planstufe: number;
    verwaltungsansicht: boolean;
    uhconfig: KSLPlusAPI.UhConfigModel | undefined,
    settings: KSLPlusAPI.SettingsModel;    
}



export class ABCAnalyse extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state.abc = props.abc;
    }

    node: any;    
    container: any = null;

    

    
    state: State = {
        ready: false,
        hhPr: null,
        hhPRModal: false,
        expanded: [],
        hhPrs: {},
        hhGL: null,
        hierDoppisch: null,
        hierKameral: null,
        selected: "",
        abc: null
    }

    handleSelectHHEbeneKameral = (ebene: KSLPlusAPI.HaushaltsEbene, selected: string) => {        
        this.state.selected = ebene.id !== (this.state.hierKameral?.id ?? "") ? ebene.id ?? selected : "";
        this.readABCAnalyseKameral();
        this.setState({ selected: ebene.id ?? selected });                
    }

    handleSelectHHEbeneDoppisch = (ebene: KSLPlusAPI.HaushaltsHiearchieDoppik, selected: string) => {
        this.state.selected = ebene.ebenenId !== (this.state.hierDoppisch?.ebenenId ?? "") ? ebene.ebenenId ?? selected : "";
        this.readABCAnalyseDoppisch();
        this.setState({ selected: ebene.ebenenId ?? selected });
    }

    readABCAnalyseDoppisch = () => {
        this.state.abc = null;
        
        const api = env.REACT_APP_KSLPLUS_API || "https://localhost:5001";
        var client = new KSLPlusAPI.DigitalHousholdDoppik_Client(api);

        client.aBCAnalysis(this.props.kunde, this.props.gemeinde, this.props.jahr, this.props.plantyp, this.props.planstufe, this.props.uhconfig && this.props.uhconfig.id ? this.props.uhconfig.id : 0, this.props.verwaltungsansicht, this.state.selected, "").then(abc => {            
            this.setState({ abc: abc });
            
        }).catch(Reason => {                
        });
    }

    readABCAnalyseKameral = () => {
        this.state.abc = null;

        const api = env.REACT_APP_KSLPLUS_API || "https://localhost:5001";
        var client = new KSLPlusAPI.DigitalHoushold_Client(api);

        client.aBCAnalysis(this.props.kunde, this.props.gemeinde, this.props.jahr, this.props.plantyp, this.props.planstufe, this.props.uhconfig && this.props.uhconfig.id ? this.props.uhconfig.id : 0, this.props.verwaltungsansicht, this.state.selected, "").then(abc => {
            this.setState({ abc: abc });

        }).catch(Reason => {
        });
    }


    readHHGLData = () => {
        var request = new KSLPlusAPI.HaushaltRequest();
        var kunde = 0;
        if (this.props.kunde === undefined)
            return;
        request.kunde = this.props.kunde;
        var gemeinde = 0;
        if (this.props.gemeinde === undefined)
            return;
        request.gemeinde = this.props.gemeinde;
        var jahr = 0;
        if (this.props.jahr === undefined)
            return;
        request.jahr = this.props.jahr;

        request.plantyp = this.props.plantyp;
        request.planstufe = this.props.planstufe;
        request.uhConfig = this.props.uhconfig ? this.props.uhconfig.id : 0;
        request.verwaltungsAnsicht = this.props.verwaltungsansicht;

        const api = env.REACT_APP_KSLPLUS_API || "https://localhost:5001";

        var client = new KSLPlusAPI.DigitalHoushold_Client(api);

        request.gruppen = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
        request.ignorierteGruppen = [3, 9];
        //request.ignorierteGruppen = [800, 801, 802, 803, 804, 805, 806, 807, 808, 86, 201, 202, 203, 204, 205, 206, 207, 208, 28, 3, 9];
        client.getHaushaltByGliederung("", request).then((hh) => {
            
            this.setState({ ready: true, hhGL: hh });
        }).catch(Reason => {
        });
        /*        
        request.gruppen = [0,1,2];
        client.getHaushaltByGliederung( "", request ).then((hh) => {
            this.hhGL_Einnahmen = hh;                          
            this.setState({ ready: true });
        }).catch(Reason => {
            alert("failed");
        });

        request.gruppen = [4, 5, 6, 7, 8];
        client.getHaushaltByGliederung("", request).then((hh) => {
            this.hhGL_Einnahmen = hh;
            this.readHHGRData();
            this.setState({ ready: true });
        }).catch(Reason => {
            alert("failed");
        });
        */

    }

    
    readEbenenHierDoppisch = () => {        
        if ((this.props.abc.ebenen ?? "") === "")
            return;

        var request = new KSLPlusAPI.HaushaltRequestDoppik();
        var kunde = 0;
        if (this.props.kunde === undefined)
            return;
        request.kunde = this.props.kunde;
        var gemeinde = 0;
        if (this.props.gemeinde === undefined)
            return;
        request.gemeinde = this.props.gemeinde;
        var jahr = 0;
        if (this.props.jahr === undefined)
            return;
        request.jahr = this.props.jahr;

        request.plantyp = this.props.plantyp;
        request.planstufe = this.props.planstufe;
        request.uhConfig = this.props.uhconfig && this.props.uhconfig.id ? this.props.uhconfig.id : 0;
        request.ebene = this.props.abc.ebenen;        
        request.multiEbenen = true;
        request.verwaltungsAnsicht = this.props.verwaltungsansicht;
        request.summenTyp = (this.props.plantyp < 3) ? 2 : ((this.props.plantyp === 3) ? 7 : 19);        
        const api = env.REACT_APP_KSLPLUS_API || "https://localhost:5001";

        var client = new KSLPlusAPI.DigitalHousholdDoppik_Client(api);

        client.getHaushaltsHierarchieByEbene("", request).then((hh) => {                        
            this.setState({ ready: true,  hierDoppisch: hh});           
        }).catch(Reason => {            
        });
    }

    readEbenenHierKameral = () => {
        var request = new KSLPlusAPI.HaushaltRequest();
        var kunde = 0;
        if (this.props.kunde === undefined)
            return;
        request.kunde = this.props.kunde;
        var gemeinde = 0;
        if (this.props.gemeinde === undefined)
            return;
        request.gemeinde = this.props.gemeinde;
        var jahr = 0;
        if (this.props.jahr === undefined)
            return;
        request.jahr = this.props.jahr;

        request.plantyp = this.props.plantyp;
        request.planstufe = this.props.planstufe;
        request.uhConfig = this.props.uhconfig && this.props.uhconfig.id ? this.props.uhconfig.id : 0;
        request.ebene = this.props.abc.ebenen;
        request.multiEbenen = true;
        request.verwaltungsAnsicht = this.props.verwaltungsansicht;
        //request.summenTyp = this.props.summenTyp;
        const api = env.REACT_APP_KSLPLUS_API || "https://localhost:5001";

        var client = new KSLPlusAPI.DigitalHoushold_Client(api);

        client.getHaushaltByEbene("", request).then((hh) => {
            this.setState({ ready: true, hierKameral: hh });
        }).catch(Reason => {
        });
    }
    

    componentDidMount() {
        if (this.props.buchungsart == 1) {
            this.readHHGLData();
            this.readEbenenHierKameral();
        }
        else
            this.readEbenenHierDoppisch();        
    }

    rowStyle = (row: KSLPlusAPI.ABCResultEbene, rowIdx: number) => {
        const style:any = {};
        if (row.klassifikation === 'A') {            
            style.backgroundColor = this.state.abc?.farbeA ? this.state.abc.farbeA : '#ffb09c';
        }
        else if (row.klassifikation === 'B') {
            style.backgroundColor = this.state.abc?.farbeB ? this.state.abc?.farbeB : '#FFFBC8';
        }
        else if ( row.klassifikation === 'C' ) {
            style.backgroundColor = this.state.abc?.farbeC ? this.state.abc?.farbeC : '#D8FCD8';
        }
        else {
            style.backgroundColor = this.state.abc?.farbePos ? this.state.abc?.farbePos : 'white';
        }
        

        return style;
    }

    rowClasses = (row: KSLPlusAPI.ABCResultEbene, rowIdx: number) => {
        if (rowIdx > 0 && this.state.abc?.negResults && this.state.abc?.negResults[rowIdx].klassifikation !== this.state?.abc.negResults[rowIdx - 1].klassifikation)
            return "kslplus-abcanlysis-rowborder";

        return "kslplus-abcanlysis-row";
    }
    
    createNegColumns = () => {
        var columns = [];


        var id = 1;
        columns.push({
            dataField: 'uaFmt',
            text: this.props.buchungsart === 2 ? "Produkt" : "Unterabschnitt",
            align: 'right',
            headerStyle: (colum: any, colIndex: any) => {
                return { width: '50px', textAlign: 'right' };
            },
            footer: 0,
            footerAlign: 'right',
            footerFormatter: (column: any, columnIndex: any) => {
                return null;
            }
        });
        
        columns.push({
            dataField: 'uaText',
            text: "Bezeichnung",
            headerStyle: (colum: any, colIndex: any) => {
                return { width: '250px', textAlign: 'left' };
            },
            footer: 1,            
            footerAlign: 'left',
            footerFormatter: (column: any, columnIndex: any) => {                
                return (
                    <div className="kslplus-tabellen-footer">Negativer Deckungsbeitrag insgesamt</div>
                );
            }            
        });


        var nk = this.props.plantyp < 3 && this.props.settings.ansatzOhneDS ? 0 : (this.props.settings.nk ?? 2);    

        columns.push({
            dataField: 'resultAbs',
            text: "Deckungsbeitrag",
            align: 'right',
            headerStyle: (colum: any, colIndex: any) => {
                return { width: '75px', textAlign: 'right' };
            },
            formatter: (cellContent: string, row: KSLPlusAPI.ABCResultEbene) => {                        
                return (
                    <div>{Utilities.FormatCurrency(row.resultAbs, nk, 3, '.', ',')  + " " + this.props.settings.waehrung}</div>
                );

            },
            footer: 2,            
            footerAlign: 'right',
            footerFormatter: (column: any, columnIndex: any) => {
                return (
                    <div className="kslplus-tabellen-footer">{Utilities.FormatCurrency(this.state.abc?.negResultAbs, nk, 3, '.', ',') + " " + this.props.settings.waehrung}</div>
                );
            }
        });

        columns.push({
            dataField: 'resultRel',
            text: "Anteil",
            align: 'right',
            headerStyle: (colum: any, colIndex: any) => {
                return { width: '30px', textAlign: 'right' };
            },
            formatter: (cellContent: string, row: KSLPlusAPI.ABCResultEbene) => {
                return (
                    <div>{Utilities.FormatCurrency(row.resultRel, 2, 3, '.', ',') + " %"}</div>
                );

            },
            footer: 3,          
            footerAlign: 'right',
            footerFormatter: (column: any, columnIndex: any) => {
                return (
                    <div className="kslplus-tabellen-footer">100,00 %</div>
                );
            }
        });

        columns.push({
            dataField: 'resultRelKumuliert',
            text: "kum. Anteil",
            align: 'right',
            headerStyle: (colum: any, colIndex: any) => {
                return { width: '30px', textAlign: 'right' };
            },
            formatter: (cellContent: string, row: KSLPlusAPI.ABCResultEbene) => {
                return (
                    <div>{Utilities.FormatCurrency(row.resultRelKumuliert, 2, 3, '.', ',') + " %"}</div>
                );

            },
            footer: 4,            
            footerFormatter: (column: any, columnIndex: any) => {
                return null;
            }
        });

        columns.push({
            dataField: 'klassifikation',
            text: "Klasse",
            align: 'right',
            headerStyle: (colum: any, colIndex: any) => {
                return { width: '30px', textAlign: 'right' };
            },
            formatter: (cellContent: string, row: KSLPlusAPI.ABCResultEbene) => {
                return (
                    <div>{row.klassifikation}</div>
                );

            },
            footer: 5,            
            footerFormatter: (column: any, columnIndex: any) => {
                return null;
            }
        });

        return columns;
    }

    createPosColumns = () => {
        var columns = [];


        var id = 1;
        columns.push({
            dataField: 'uaFmt',
            text: this.props.buchungsart === 2 ? "Produkt" : "Unterabschnitt",
            align: 'right',
            headerStyle: (colum: any, colIndex: any) => {
                return { width: '50px', textAlign: 'right' };
            },
            footer: 0,            
            footerFormatter: (column: any, columnIndex: any) => {
                return null;
            }
        });

        columns.push({
            dataField: 'uaText',
            text: "Bezeichnung",
            headerStyle: (colum: any, colIndex: any) => {
                return { width: '250px', textAlign: 'left' };
            },
            footer: 1,            
            footerAlign: 'left',
            footerFormatter: (column: any, columnIndex: any) => {
                return (
                    <div>
                        <div className="kslplus-tabellen-footer">Positiver Deckungsbeitrag insgesamt</div>
                        <div className="kslplus-tabellen-footer">Negativer Deckungsbeitrag insgesamt</div>
                        <div className="kslplus-tabellen-footer">Gesamtergebnis</div>
                    </div>
                );
            }
        });

        var nk = this.props.plantyp < 3 && this.props.settings.ansatzOhneDS ? 0 : 2;    
        columns.push({
            dataField: 'resultAbs',
            text: "Deckungsbeitrag",
            align: 'right',
            headerStyle: (colum: any, colIndex: any) => {
                return { width: '75px', textAlign: 'right' };
            },
            formatter: (cellContent: string, row: KSLPlusAPI.ABCResultEbene) => {
                return (
                    <div>{Utilities.FormatCurrency(row.resultAbs, nk, 3, '.', ',') + " " + this.props.settings.waehrung}</div>
                );

            },
            footer: 2,            
            footerAlign: 'right',
            footerFormatter: (column: any, columnIndex: any) => {
                return (
                    <div>
                        <div className="kslplus-tabellen-footer">{Utilities.FormatCurrency(this.state.abc?.posResultAbs, nk, 3, '.', ',') + " " + this.props.settings.waehrung}</div>
                        <div className="kslplus-tabellen-footer">{Utilities.FormatCurrency(this.state.abc?.negResultAbs, nk, 3, '.', ',') + " " + this.props.settings.waehrung}</div>
                        <div className="kslplus-tabellen-footer">{Utilities.FormatCurrency((this.state.abc?.posResultAbs !== undefined ? this.state.abc?.posResultAbs : 0) + (this.state.abc?.negResultAbs !== undefined ? this.state.abc?.negResultAbs : 0), nk, 3, '.', ',') + " " + this.props.settings.waehrung}</div>
                    </div>
                );
            }
        });

        columns.push({
            dataField: 'resultRel',
            text: "Anteil",
            align: 'right',
            headerStyle: (colum: any, colIndex: any) => {
                return { width: '30px', textAlign: 'right' };
            },
            formatter: (cellContent: string, row: KSLPlusAPI.ABCResultEbene) => {
                return (
                    <div>{Utilities.FormatCurrency(row.resultRel, 2, 3, '.', ',') + " %"}</div>
                );

            },
            footer: 3,            
            footerFormatter: (column: any, columnIndex: any) => {
                return null;
            }
        });

        columns.push({
            dataField: 'resultRelKumuliert',
            text: "kum. Anteil",
            align: 'right',
            headerStyle: (colum: any, colIndex: any) => {
                return { width: '30px', textAlign: 'right' };
            },
            formatter: (cellContent: string, row: KSLPlusAPI.ABCResultEbene) => {                
                return (
                    <div>{Utilities.FormatCurrency(row.resultRelKumuliert, 2, 3, '.', ',') + " %"}</div>
                );

            },
            footer: 4,            
            footerFormatter: (column: any, columnIndex: any) => {
                return null;
            }
        });
        

        return columns;
    }



    expandRow = {
        /*
        renderer: (row: KSLPlusAPI.ABCResultEbene) => (
            this.state.hhPrs[row.uaFmt ? row.uaFmt : ""] != null ? <HHSummiertDoppisch hh={this.state.hhPrs[row.uaFmt ? row.uaFmt : ""]} plantyp={this.props.plantyp} jahr={this.props.jahr} isVisible={true} settings={this.props.settings} summenTyp={3} uhconfig={this.props.uhconfig} callerID={row.uaFmt ? row.uaFmt : ""} />
                : <div className="d-flex justify-content-center"> <Spinner color="primary" /></div>
        ),
        */
        renderer: (row: KSLPlusAPI.ABCResultEbene) => (
            this.props.buchungsart == 2 ?
                <ProduktSpezHaushalt kunde={this.props.kunde} gemeinde={this.props.gemeinde} ebene={this.state.selected} produkt={row.uaFmt ? row.uaFmt : ""} plantyp={this.props.plantyp} planstufe={this.props.planstufe} jahr={this.props.jahr} isVisible={true} settings={this.props.settings} summenTyp={3} uhconfig={this.props.uhconfig} verwaltungsansicht={this.props.verwaltungsansicht} />
                :
                this.state.hhGL != null ?
                    <GLHaushalt hh={this.state.hhGL} onSelChange={(ebene: string) => { }} ebene={this.state.selected}  isvmhh={false} massnahmen={[]} kunde={this.props.kunde} gemeinde={this.props.gemeinde} selected={row.uaFmt ? row.uaFmt : ""} plantyp={this.props.plantyp} planstufe={this.props.planstufe} jahr={this.props.jahr} settings={this.props.settings} uhconfig={this.props.uhconfig} verwaltungsansicht={this.props.verwaltungsansicht} hideNav={true} isVisible={true} />
                    :
                    null
        ),
        className: 'kslplus-tabellen-expanded',
        //expanded: this.state.expanded,
        //onExpand: this.handleOnExpand,
        showExpandColumn: true,
        expandHeaderColumnRenderer: ({ isAnyExpands }: { isAnyExpands: boolean }) => {
            return null;
        }     
    };


    

    render() {                 
        return (            
                <div className="kslplus-abcanlysis">
                    {this.props.buchungsart === 2 && this.state.hierDoppisch !== null && (this.state.hierDoppisch?.unterEbenen?.length ?? 0) > 0 &&
                        <ProduktNavTree hh={JSON.parse(JSON.stringify(this.state.hierDoppisch))} onSelChange={this.handleSelectHHEbeneDoppisch} selected={this.state.selected} showNumber={true} typ={EbenenTypDoppisch.FreieEbenen} auswahlText="Auswahl Ebene od. Suche per Eingabe" />
                    }
                    {this.props.buchungsart === 1 && this.state.hierKameral !== null && (this.state.hierKameral?.unterEbenen?.length ?? 0) > 0 &&
                        <HaushaltsNavTree hh={this.state.hierKameral} gesamtHH={true} onSelChange={this.handleSelectHHEbeneKameral} selected={this.state.selected} useUAText={true} showNumber={true} typ={EbenenTyp.FreieEbenen} auswahlText="Auswahl nach Ebene od. Suche per Eingabe" />
                }
                {this.state.abc &&
                    <>
                        <Row>
                            <Col className="kslplus-beschreibung-content">
                                <div className="content" dangerouslySetInnerHTML={{ __html: this.state.abc.textOben ? this.state.abc.textOben : "" }}></div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <BootstrapTable hover={false} bordered={false} keyField='id' data={this.state.abc.negResults} columns={this.createNegColumns()} rowStyle={this.rowStyle} rowClasses={this.rowClasses} expandRow={this.expandRow} />
                            </Col>
                        </Row>
                        <Row>
                            <Col className="kslplus-beschreibung-content">
                                <div className="content" dangerouslySetInnerHTML={{ __html: this.state.abc.textMitte ? this.state.abc.textMitte : "" }}></div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <BootstrapTable hover={false} bordered={false} keyField='id' data={this.state.abc.posResults} columns={this.createPosColumns()} rowStyle={this.rowStyle} expandRow={this.expandRow} />
                            </Col>
                        </Row>
                        <Row>
                            <Col className="kslplus-beschreibung-content">
                                <div className="content" dangerouslySetInnerHTML={{ __html: this.state.abc.textUnten ? this.state.abc.textUnten : "" }}></div>

                            </Col>
                        </Row>
                    </>}
                    <Modal id="ksl-modal-hh-doppisch" size="xl" contentClassName="ksl-modal-drilldown" isOpen={this.state.hhPRModal} toggle={() => this.setState({ hhPRModal: false })} backdrop="static">
                        <ModalHeader toggle={() => this.setState({ hhPRModal: false })}>Haushaltsdaten</ModalHeader>
                        <ModalBody>
                            {this.state.hhPr != null ?
                                <HHSummiertDoppisch hh={this.state.hhPr} plantyp={this.props.plantyp} jahr={this.props.jahr} isVisible={true} settings={this.props.settings} summenTyp={3} uhconfig={this.props.uhconfig} callerID={"3-abc"} verwaltungsansicht={this.props.verwaltungsansicht} />
                                : <div className="d-flex justify-content-center"> <Spinner color="primary" /></div>
                            }
                        </ModalBody>
                    </Modal>

                </div>
            
        );
    }
}